export default __webpack_public_path__ + "static/media/gutmicro_logo.37b5b656.svg";